import { FC, useEffect } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import styles from "./Profile.module.scss";
import { useProfile } from "./hooks/useProfile";
import Content from "./components/Content";
import Balance from "./components/Balance";
import WalletAddress from "./components/WalletAddress";
import { useTonConnectUI } from "@tonconnect/ui-react";

const Profile: FC = () => {
    const {
        currency,
        handleChooseCurrency,
        portfolioItems,
        openModal,
        isMenuVisible,
        setIsMenuVisible,
        currencies,
        currentPortfolioItem,
        setCurrentPortfolioItem,
        refreshWalletData,
    } = useProfile();

    const [tonConnectUI] = useTonConnectUI();

    // Fetch wallet data when component mounts
    useEffect(() => {
        // Refresh wallet data on component mount
        refreshWalletData();
    }, [refreshWalletData]);

    return (
        <>
            <Content>
                <div className={styles.top}>
                    <WalletAddress showSelectModal={() => openModal("select")} />
                    <div className={styles.buttons}>
                        <Link to={"/pricing"} className={styles.button}>
                            <span>Subscribe</span>
                            <img width={16} height={16} src="/images/profile/subscribe.svg" alt="" />
                        </Link>
                        <button onClick={() => openModal("connect")} className={styles.button}>
                            <span>Connect wallet</span>
                            <img width={14} height={14} src="/images/profile/plus.svg" alt="" />
                        </button>

                        <button onClick={() => openModal("referal")} className={styles.button}>
                            <span>Referrals</span>
                            <img width={18} height={18} src="/images/profile/referals.svg" alt="" />
                        </button>
                        <button onClick={() => openModal("disconnect")} className={styles.button}>
                            <span>Disconnect wallet</span>
                            <img src="/images/profile/close.svg" alt="" />
                        </button>
                    </div>

                    <div className={cn(styles.buttons, styles.buttonsMobile)}>
                        <button onClick={() => openModal("mobile")} className={styles.button}>
                            <img className="min-w-7" width={24} height={24} src="/images/profile/dots.svg" alt="" />
                        </button>
                        {tonConnectUI.connected && (
                            <button onClick={() => openModal("disconnect")} className={styles.button}>
                                <img width={9} height={9} src="/images/profile/close.svg" alt="" />
                            </button>
                        )}
                    </div>
                </div>

                <div className={styles.blocks}>
                    <div className={styles.block}>
                        <h2 className={styles.blockTitle}>Balance</h2>
                        <div className={styles.holder}>
                            <button onClick={() => setIsMenuVisible(!isMenuVisible)} className={styles.blockButton}>
                                <span>
                                    {currencies[currency]?.value.toFixed(2)} {currencies[currency]?.name}
                                </span>
                                <img src="/images/profile/down.svg" alt="" />
                            </button>
                            <ul className={cn(styles.blockList, { [styles.active]: isMenuVisible })}>
                                {currencies.map(({ name }, i) => (
                                    <li key={name} className={styles.blockItem}>
                                        <button onClick={() => handleChooseCurrency(i)} type="button">
                                            {name}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </Content>
            <div className={styles.portfolio + " w-full"}>
                <div className={styles.content}>
                    {portfolioItems.length > 0 && (
                        <>
                            <h2 className={styles.title}>Portfolio</h2>
                            <Balance
                                currentPortfolioItem={currentPortfolioItem}
                                portfolioItems={portfolioItems}
                                setCurrentPortfolioItem={setCurrentPortfolioItem}
                                sortedPortfolioItems={portfolioItems}
                            />
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default Profile;
